<template>
  <v-card v-if="isEngagementScoreEnabled"
          class="mb-4">
    <v-card-title class="d-flex">
      <div class="mr-1">
        Engagement Score
      </div>
      <v-btn :href="helpURL"
             target="_blank"
             color="primary"
             icon>
        <v-icon>
          fas fa-question-circle
        </v-icon>
      </v-btn>
    </v-card-title>
    <v-card-text>
      <div class="d-flex align-center">
        <v-progress-linear :color="engagementScoreColor"
                           height="40"
                           :value="engagementScore"
                           class="mr-4">
        </v-progress-linear>
        <h1>
          {{ engagementScore }}
        </h1>
      </div>
    </v-card-text>
  </v-card>
</template>
<script>
import {mapGetters} from 'vuex';
import engagementScoreService from '../../../services/engagementScoreService';

export default {
  props: {
    score: {
      type: Number,
      required: true,
    },
    type: {
      type: String,
      default: 'template',
    },
  },
  computed: {
    ...mapGetters([
      'isEngagementScoreEnabled',
    ]),
    helpURL() {
      if (this.type === 'campaign') {
        return 'https://help.mobilelocker.com/article/233-understanding-the-campaign-engagement-score';
      }
      return 'https://help.mobilelocker.com/article/232-understanding-the-engagement-score-a-guide-for-administrators';
    },
    engagementScore() {
      return this.score;
    },
    engagementScoreColor() {
      return engagementScoreService.engagementScoreColor(this.engagementScore);
    },
  },
}
</script>
